import React, { Children } from 'react';
import { LeafIcon } from 'lucide-react';
const conditions = ['Headaches & Migraines', 'Fever & Chills', 'Cough, Cold & Congestion', 'Sore Throat & Tonsils', 'Digestive Issues & Bloating', 'Nausea & Stomach Pain', 'Sleep Problems & Insomnia', 'Anxiety & Stress', 'Hormonal Imbalances', 'PMS & Menstrual Pain', 'Skin Issues (Rashes, Acne, Eczema)', 'Immune System Support', "Children's Common Ailments", 'Inflammation & Joint Pain', 'Energy & Fatigue', 'And 50+ more conditions covered'];
export function HandbookContents() {
  return <section className="py-8 md:py-14 bg-cream" data-id="element-120">
      <div className="max-w-5xl mx-auto px-4" data-id="element-121">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-5 md:mb-8" data-id="element-122">
          WHAT'S INSIDE THE HANDBOOK
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-123">
          {conditions.map((condition, index) => <div key={index} className="bg-white border border-primary/10 rounded-lg p-3 md:p-4 flex items-center gap-2" data-id="element-124">
              <LeafIcon className="w-4 h-4 text-primary flex-shrink-0" data-id="element-125" />
              <span className="text-sm text-dark" data-id="element-126">{condition}</span>
            </div>)}
        </div>

        <div className="bg-primary/5 border border-primary/20 rounded-xl p-4 md:p-6 text-center" data-id="element-127">
          <p className="text-dark font-medium" data-id="element-128">
            Each remedy includes:{' '}
            <span className="text-primary" data-id="element-129">exact ingredients</span> ·{' '}
            <span className="text-primary" data-id="element-130">dosage</span> ·{' '}
            <span className="text-primary" data-id="element-131">preparation time</span> ·{' '}
            <span className="text-primary" data-id="element-132">
              substitutes if you can't find the herb
            </span>{' '}
            · <span className="text-primary" data-id="element-133">safety notes</span>
          </p>
        </div>
      </div>
    </section>;
}